import { useState, useEffect, } from 'react';
import { Link } from "react-router-dom";
import StoreService from "./../services/service.store";

export default function Footer() {

    const [stateList, setStateList] = useState([])

    useEffect(() => {

        StoreService.geStateList('store').then((response) => {
            setStateList(response.data.data.states)
        }).catch((err) => console.log('State List Error', err))

    }, [])

    return <footer id="footer">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h4>States :</h4>
                    <div className="store-list">
                        {stateList?.sort().map((state, index) => {
                            return <Link to={`/storelocator/location/${state}`} key={index}>
                                {state} /{" "}
                            </Link>
                        })}
                    </div>
                </div>
            </div>
        </div>
        <div className="footer-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <p className="copyright">
                            <i className="fa fa-copyright" aria-hidden="true" />{" "}
                            Copyright 2021 Reliancejewels.Com. All Rights Reserved.
                        </p>{" "}
                    </div>
                </div>
            </div>
        </div>
    </footer>
}
